<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>

  <section>
    <div class="header-background"></div>
    <div class="content-wrapper pos-rel-md">
      <app-page-retrieval-error
        *ngIf="pageRetrievalError"
      ></app-page-retrieval-error>
      <h1>{{ pageData.title }}</h1>
      <div class="separator"></div>
      <div class="content">
        <app-render-markdown [content]="pageData.body"></app-render-markdown>
      </div>
    </div>
  </section>
</div>
